import { render, staticRenderFns } from "./SongpeiGoodsList.vue?vue&type=template&id=0d70c3e7&scoped=true&"
import script from "./SongpeiGoodsList.vue?vue&type=script&lang=js&"
export * from "./SongpeiGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./SongpeiGoodsList.vue?vue&type=style&index=0&id=0d70c3e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70c3e7",
  null
  
)

export default component.exports